import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {MultiSelectModule} from 'primeng/multiselect';
import {FieldsetModule} from 'primeng/fieldset';
import {DatePickerModule} from 'primeng/datepicker';
import {DropdownModule} from 'primeng/dropdown';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ChipsModule} from 'primeng/chips';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DialogModule} from 'primeng/dialog';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {TabViewModule} from 'primeng/tabview';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {PanelModule} from 'primeng/panel';
import {ListboxModule} from 'primeng/listbox';
import {InputSwitchModule} from 'primeng/inputswitch';
import {TooltipModule} from 'primeng/tooltip';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {KeyFilterModule} from 'primeng/keyfilter';
import {InputNumberModule} from 'primeng/inputnumber';
// import { DmpMultiSelectModule } from "./multiselect/multiselect";
import {CheckboxModule} from 'primeng/checkbox';
import {SplitButtonModule} from 'primeng/splitbutton';
import {FileUploadModule} from 'primeng/fileupload';
import {TextareaModule} from 'primeng/textarea';
import {ToastModule} from 'primeng/toast';
import {TreeModule} from 'primeng/tree';
import {PickListModule} from 'primeng/picklist';
import {RadioButtonModule} from 'primeng/radiobutton';
import {StepsModule} from 'primeng/steps';
import {AccordionModule} from 'primeng/accordion';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {ConfirmationService, MessageService} from 'primeng/api';

@NgModule({
    declarations: [],
    exports: [
        InputNumberModule,
        StepsModule,
        TreeModule,
        ProgressSpinnerModule,
        ButtonModule,
        TableModule,
        DropdownModule,
        DatePickerModule,
        DropdownModule,
        OverlayPanelModule,
        ButtonModule,
        ChipsModule,
        FieldsetModule,
        TableModule,
        DialogModule,
        ScrollPanelModule,
        TabViewModule,
        MessagesModule,
        MessageModule,
        BreadcrumbModule,
        PanelModule,
        ListboxModule,
        InputSwitchModule,
        TooltipModule,
        AutoCompleteModule,
        ToggleButtonModule,
        KeyFilterModule,
        MultiSelectModule,
        CheckboxModule,
        SplitButtonModule,
        FileUploadModule,
        TextareaModule,
        ToastModule,
        PickListModule,
        RadioButtonModule,
        AccordionModule,
        DynamicDialogModule,
        SelectButtonModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
    ],
    imports: [CommonModule],
    providers: [
        ConfirmationService,
        MessageService
    ]
})
export class PrimengModule {
}
